module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "endOfPage"
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_media"
  }, [_vm._v("\n      Media:\n\n      "), _c('div', {
    staticClass: "footer_media_icons"
  }, [_c('a', {
    staticClass: "footer_media_icons_social_media footer_media_icons_social_media--facebook",
    attrs: {
      "href": "https://www.facebook.com/Larp-Group-Krasja-1415785175113800/"
    }
  }, [_vm._v("facebook")]), _vm._v(" "), _c('a', {
    staticClass: "footer_media_icons_social_media footer_media_icons_social_media--youtube",
    attrs: {
      "href": "https://www.youtube.com/watch?v=OhOmeYdvYdk"
    }
  }, [_vm._v("youtube")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer_icon"
  }, [_c('img', {
    staticClass: "footer_icon_img",
    attrs: {
      "src": "http://i.imgur.com/Og6KzKR.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer_media_contact"
  }, [_vm._v("\n      Kontakt:\n\n\n      "), _c('div', {
    staticClass: "footer_media_contact_phone"
  }, [_c('a', {
    staticClass: " footer_media_contact_phone_owner",
    attrs: {
      "href": "tel: 570267495"
    }
  }, [_vm._v("725 085 596")])]), _vm._v(" "), _c('div', {
    staticClass: "footer_media_contact_email"
  }, [_c('a', {
    staticClass: " footer_media_contact_email_owner",
    attrs: {
      "href": "mailto: koniecznyprecel@hotmail.com"
    }
  }, [_vm._v("kkrasja@gmail.com")])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer_author"
  }, [_c('h1', [_vm._v("Created by "), _c('a', {
    staticClass: "footer_author_link",
    attrs: {
      "href": "http://rafal-krukowski.c0.pl/"
    }
  }, [_vm._v("Rafał Krukowski")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-048bac06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/endOfPage/endOfPage.vue
// module id = 26
// module chunks = 0